import { createClient } from '@supabase/supabase-js'
import { env } from './env'

const supabaseUrl = env.VITE_SUPABASE_URL
const supabaseAnonKey = env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

/**
 * Where the Supabase session is kept in localStorage. Exported so logout can remove it when
 * `signOut()` fails: supabase-js only deletes it after the server confirms the sign-out (FF-4076).
 * Set explicitly so the name does not depend on the Supabase project URL.
 */
export const SUPABASE_STORAGE_KEY = 'fanfair-partner-auth'

/**
 * Where supabase-js keeps the PKCE code verifier while a password reset or sign-up email link is
 * pending. supabase-js chooses this name, and `supabase.test.ts` checks that it still uses it.
 * Logout removes it when `signOut()` fails, as supabase-js does after a successful sign-out (FF-4107).
 */
export const SUPABASE_CODE_VERIFIER_KEY = `${SUPABASE_STORAGE_KEY}-code-verifier`

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: window.localStorage,
    storageKey: SUPABASE_STORAGE_KEY,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
    flowType: 'pkce'
  }
})

// Debug: Log storage contents on initialization
console.log('[Supabase] Initialized with storage keys:', Object.keys(window.localStorage).filter(key => key.includes('supabase')))
